import React from 'react'
import { Link } from 'react-router-dom'
import { useSelection } from '../../context/SelectionContext'
import Product from '../Product'
import { SectionTitle } from './ui'

const GRUPY = [
  { type: 'panel', title: 'Moduły PV' },
  { type: 'inwerter', title: 'Falowniki' },
  { type: 'magazyn', title: 'Magazyny' },
]

/**
 * Obserwowane produkty WEWNĄTRZ panelu konta.
 *
 * Wcześniej była to osobna pozycja w górnej nawigacji. Pasek jest jednak wspólny
 * dla wszystkich, a obserwowane dotyczą jednej osoby — miejsce w nim zwolniło się
 * na „Dodaj siebie", które ma dowozić nowych wykonawców i sklepy.
 *
 * Trasa `/obserwowane` ZOSTAJE: linki do niej mogły już gdzieś krążyć, a jej
 * usunięcie dałoby pustą stronę bez komunikatu (w routingu nie ma trasy 404).
 */
const ObservedSection = () => {
  const { favoritesList } = useSelection()

  const wgTypu = { panel: [], inwerter: [], magazyn: [] }
  favoritesList.forEach(({ product, productType }) => {
    if (wgTypu[productType]) wgTypu[productType].push(product)
  })
  const razem = favoritesList.length

  return (
    <div>
      <SectionTitle hint={razem > 0 ? `Zapisane produkty: ${razem}` : undefined}>
        Obserwowane
      </SectionTitle>

      {razem === 0 ? (
        <div className="text-center py-10">
          <p className="text-sm text-gray-500 mb-4">Nie obserwujesz jeszcze żadnych produktów.</p>
          <Link to="/panele"
                className="inline-block px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-500 transition-colors">
            Przeglądaj produkty
          </Link>
        </div>
      ) : (
        GRUPY.filter(({ type }) => wgTypu[type].length > 0).map(({ type, title }) => (
          <div key={type} className="mb-8 last:mb-0">
            <h3 className="text-base font-bold text-blue-600 mb-3">
              {title} <span className="text-gray-400 font-normal text-sm">({wgTypu[type].length})</span>
            </h3>
            <ul>
              {wgTypu[type].map((p) => (
                <Product key={`${type}:${p.id}`} product={p} productType={type} />
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  )
}

export default ObservedSection
